import {CustomFieldTO} from 'generated/JavaTO'
import {CF} from 'module/CustomField/util/CustomField'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {SlctFormat} from 'module/Slct/type/SlctType'

export function useSlctCFAttrs(cfDef: CustomFieldTO) {
	if (!cfDef) return {}
	const menuWidth = Number(CF.getCFAttr(cfDef, CFAttrKey.menuWidth)?.value)
	const displayFormat = CF.getCFAttr(cfDef, CFAttrKey.displayFormat)?.value as SlctFormat
	return {menuWidth, displayFormat}
}